// removed by extract-text-webpack-plugin
module.exports = {"wealthSection":"wealthSection__1qn7L","imgContainer":"imgContainer__3Y8ZZ"};


//////////////////
// WEBPACK FOOTER
// ./components/homePageNew/growthSection/growthSection.scss
// module id = 499
// module chunks = 68